import { useQuery } from "@tanstack/react-query";

export function hasQueryValue(value) {
  return !(
    value === undefined ||
    value === null ||
    value === "" ||
    value === "undefined"
  );
}

export function hasAllQueryValues(...values) {
  return values.every(hasQueryValue);
}

export function useMappedQuery({ dataKey = "data", ...queryOptions }) {
  const query = useQuery(queryOptions);

  if (dataKey === "data") {
    return query;
  }

  return {
    ...query,
    [dataKey]: query.data,
  };
}
